var React = require('react');

function CloseModal (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M12.698.333l.969.97L7.969 7l5.698 5.698-.97.969L7 7.969l-5.698 5.698-.969-.97L6.031 7 .333 1.302l.97-.969L7 6.031z","fill":"#000","fillRule":"evenodd"}));
}

CloseModal.defaultProps = {"width":"14","height":"14","viewBox":"0 0 14 14"};

module.exports = CloseModal;

CloseModal.default = CloseModal;
